import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrResponseMedium } from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrResponseMedium = (responseMedium?: PqrResponseMedium) => {
    const formik = useFormik({
        initialValues: {
            responseMedium: '',
            observation: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            responseMedium: useGetNameOrValue(
                responseMedium?.responseMedium || ''
            ),
            observation: responseMedium?.observation || '',
        });
    }, [responseMedium]);

    return {
        formik,
    };
};
